function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import RichTextEditorPresentation from "./Presentation";
import { Theme } from "../../services/events/types";
import { useEventSpaceThemeQuery } from "../../services/theme";
import { Spin } from "antd";
export * from "./Presentation";
var RichTextEditor = function(_param) {
    var eventId = _param.eventId, props = _objectWithoutProperties(_param, [
        "eventId"
    ]);
    var _useEventSpaceThemeQuery = useEventSpaceThemeQuery([
        eventId
    ]), theme = _useEventSpaceThemeQuery.data, isLoading = _useEventSpaceThemeQuery.isLoading;
    var _theme_linkTextColor;
    var linkColor = (_theme_linkTextColor = theme === null || theme === void 0 ? void 0 : theme.linkTextColor) !== null && _theme_linkTextColor !== void 0 ? _theme_linkTextColor : Theme.defaultLinkTextColor;
    return isLoading ? /*#__PURE__*/ React.createElement(Spin, null) : /*#__PURE__*/ React.createElement(RichTextEditorPresentation, _extends({}, props, {
        eventId: eventId,
        linkColor: linkColor
    }));
};
export default RichTextEditor;
